// Wire types for the Verified Domains feature (E3 F3-5). Mirror the CORE DTOs
// (Models.Datasets.VerifiedDomains): status 1-3, scope 1/2, and the verify result code which
// starts at 1 (so a default is never a spurious "Verified").

export enum VerifiedDomainStatus {
  Pending = 1,
  Verified = 2,
  Failed = 3,
}

export enum VerifiedDomainScope {
  Tenant = 1,
  Customer = 2,
}

export enum VerifiedDomainResultCode {
  Verified = 1,
  Failed = 2,
  StaleVerification = 3,
  NotFound = 4,
}

export interface VerifiedDomainDto {
  id: number
  tenantId: number
  customerId?: number
  domainName: string
  status: VerifiedDomainStatus
  verifiedAt?: string
  lastVerificationAttemptAt?: string
  verificationFailureReason?: string
}

export interface CreateVerifiedDomainRequest {
  domainName: string
  scope: VerifiedDomainScope
  customerId?: number
}

export interface CreateVerifiedDomainResponse {
  id: number
  verificationToken: string
  dnsRecordExample: string
}

export interface AttemptVerifyDomainResponse {
  resultCode: VerifiedDomainResultCode
  failureReason?: string
}
